import { CONTROL_BUCKET, IDENTIFIER_BCID, TREATMENT_BUCKET } from './default-buckets';

const BUCKETS = [CONTROL_BUCKET, TREATMENT_BUCKET];
const IDENTIFIER = IDENTIFIER_BCID;
const NAME = 'car-stc-cvt-new-hero-design';

export { BUCKETS, CONTROL_BUCKET, TREATMENT_BUCKET, IDENTIFIER, NAME };
